export enum TaskCommentLevel {
  Parent = 0,
  Child = 1,
  ChildOfChild = 2
}
